import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CountryMetadata } from '@shared/models/data-model';
import { CountryService } from '@shared/services/country.service';

export const countryListResolver: ResolveFn<CountryMetadata[]> = (route, state) => {
    return inject(CountryService).getCurrentCountries();
};
